<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* --- 全局科技风变量定义 (Tech-Style Variables) --- */
:root {
  --tech-bg-deep: #050B14;
  --tech-bg-lighter: #0A1525;
  --tech-primary: #0099FF;
  --tech-primary-hover: #40B4FF;
  --tech-secondary: #0044AA;
  --tech-success: #00FF99;
  --tech-warning: #FFBB00;
  --tech-error: #FF3355;
  --tech-text-main: #E0E6ED;
  --tech-text-sub: #8DAAC7;
  --tech-border: 1px solid rgba(0, 153, 255, 0.3);
  --tech-shadow-blue: 0 0 15px rgba(0, 153, 255, 0.2);
}

/* 全局样式重置 */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--tech-bg-deep);
  color: var(--tech-text-main);
}

#app {
  height: 100vh;
  overflow: hidden;

  /* --- [核心修改] 背景图配置 --- */

  /* 1. 设置兜底背景色 (深黑)，图片加载失败或未加载时显示 */
  background-color: var(--tech-bg-deep);

  /* 2. PC 端背景图 (默认) */
  /* 注意：在 Vue CSS 中使用 ~@ 代表 src 目录 */
  background-image: url('~@/assets/pc_background.jpg');

  /* 3. 背景图显示模式：覆盖全屏、居中、不重复 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  /* 4. 可选：增加一层黑色半透明遮罩，防止背景图太花干扰文字阅读 */
  /* 如果您的图片已经处理过比较暗，这行可以去掉；如果图片太亮，建议保留 */
  box-shadow: inset 0 0 200px rgba(0, 0, 0, 0.5);
}

/* --- [核心修改] 移动端背景适配 --- */
@media (max-width: 768px) {
  #app {
    /* 切换为竖版移动端背景 */
    background-image: url('~@/assets/mobile_background.png');
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 153, 255, 0.3);
  border-radius: 3px;
}
::-webkit-scrollbar-track {
  background: transparent;
}

/* =========================================================
   全局 Dropdown (下拉菜单) 样式覆盖 - 修复白边问题
   ========================================================= */
.el-dropdown-menu {
  background-color: rgba(10, 20, 35, 0.95) !important;
  border: 1px solid rgba(0, 153, 255, 0.3) !important;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5) !important;
  padding: 5px 0 !important;
}

.el-dropdown-menu__item {
  color: var(--tech-text-main) !important;
  transition: all 0.2s;
}

.el-dropdown-menu__item:hover, .el-dropdown-menu__item:focus {
  background-color: rgba(0, 153, 255, 0.15) !important;
  color: var(--tech-primary) !important;
}

/* 修复分割线白边 */
.el-dropdown-menu__item--divided {
  border-top-color: rgba(0, 153, 255, 0.2) !important;
  margin-top: 5px !important;
}
.el-dropdown-menu__item--divided:before {
  background-color: rgba(0, 153, 255, 0.2) !important;
  height: 1px !important;
  margin: 0 !important;
}

.el-popper[x-placement^=bottom] .popper__arrow {
  border-bottom-color: rgba(0, 153, 255, 0.3) !important;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: rgba(10, 20, 35, 0.95) !important;
}

/* =========================================================
   全局 Message & MessageBox 样式
   ========================================================= */
.el-message {
  background-color: rgba(10, 20, 35, 0.95) !important;
  border: none !important;
  border-top: 2px solid var(--tech-primary) !important;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.6) !important;
  min-width: 300px !important;
  padding: 15px 20px !important;
  border-radius: 4px !important;
  top: 30px !important;
}
.el-message .el-message__content { color: var(--tech-text-main) !important; }
.el-message .el-message__closeBtn { color: var(--tech-text-sub) !important; }
.el-message--success { border-top-color: var(--tech-success) !important; }
.el-message--success .el-message__icon { color: var(--tech-success) !important; }
.el-message--warning { border-top-color: var(--tech-warning) !important; }
.el-message--warning .el-message__icon { color: var(--tech-warning) !important; }
.el-message--error { border-top-color: var(--tech-error) !important; }
.el-message--error .el-message__icon { color: var(--tech-error) !important; }

.el-message-box {
  background-color: rgba(10, 20, 35, 0.95) !important;
  border: 1px solid var(--tech-primary) !important;
  box-shadow: 0 0 30px rgba(0, 153, 255, 0.15) !important;
  border-radius: 8px !important;
  max-width: 90% !important;
}
.el-message-box__title { color: var(--tech-primary) !important; }
.el-message-box__content { color: var(--tech-text-main) !important; }
.el-message-box .el-button--default {
  background: transparent !important;
  border: 1px solid #446 !important;
  color: #aab !important;
}
.el-message-box .el-button--default:hover {
  border-color: var(--tech-primary) !important;
  color: var(--tech-primary) !important;
}
.el-message-box .el-button--primary {
  background: var(--tech-secondary) !important;
  border: 1px solid var(--tech-primary) !important;
  color: white !important;
}
.el-message-box .el-input__inner {
  background-color: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(0, 153, 255, 0.3) !important;
  color: white !important;
}

@media (max-width: 768px) {
  .el-message-box {
    width: 85% !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>